export default "__VITE_ASSET__CICy7az6__"